/**
 * Replaces <compaction-request> tags with a visible compaction message
 * @param text - The text to process
 * @returns The text with compaction-request tags replaced with a visible message
 */
export function replaceCompactionRequest(text: string): string {
  if (!text) return text;

  // Regular expression to match <compaction-request> tags and their content
  // Uses non-greedy matching and handles multiline content
  const compactionRequestRegex = /<compaction-request>[\s\S]*?<\/compaction-request>/gi;

  return text.replace(compactionRequestRegex, '**⏳ Compacting conversation...**');
}
